import { render, staticRenderFns } from "./HotelServiceSidebar.vue?vue&type=template&id=18e52afa"
import script from "./HotelServiceSidebar.vue?vue&type=script&lang=js"
export * from "./HotelServiceSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports